import { ZipValidationDataSourceEnum } from '@inter-ikea-kompis/enums';
import { ServiceException } from '@inter-ikea-kompis/exceptions';
import DexfZipValidationService from '../../services/zip-availability/DexfZipValidationService.js';
import DexfConfiguration from '../../utilities/DexfConfiguration.js';
/**
 * This class is used as a simple interface for zip code validation services.
 */
export default class ZipValidationService {
    /**
     * @param options Options.
     */
    constructor(options) {
        this.dexfConfiguration = new DexfConfiguration(options);
    }
    /**
     * Fetches and returns zip code validity.
     *
     * @param zipCode Zip Code.
     * @returns Promise IZipValidation.
     */
    async getZipValidation(zipCode) {
        const service = await this.getService();
        return await service.getZipValidation(zipCode);
    }
    /**
     * Returns DEXF service if the zipValidationDataSource setting for the locale is not set to 'disabled'.
     *
     * @returns Service | null.
     */
    async getService() {
        const settings = await this.dexfConfiguration.getSettings();
        const dexfApiKey = await this.dexfConfiguration.getDexfApiKeyOrThrow();
        switch (settings.kompis.serviceSettings.zipValidationDataSource) {
            case ZipValidationDataSourceEnum.disabled:
                throw new ServiceException('The zipValidationDataSource is set to "disabled". When it is, the ZipValidationService is not available on the market.');
            default:
                return new DexfZipValidationService({
                    endpoint: settings.kompis.endpoints.dexfZipValidationService,
                    dexfApiKey
                });
        }
    }
}
//# sourceMappingURL=ZipValidationService.js.map